import React from "react";
import Box from "@mui/material/Box";
import { BiCalendar } from "react-icons/bi";
import moment from "moment";

export interface Props {
  dateTime: Date;
}

const classes = {
  cardContentItem: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    lineHeight: 1,
  },
} as const;

const EventStartDate = ({ dateTime }: Props) => {
  return (
    <Box sx={classes.cardContentItem}>
      <BiCalendar
        style={{ marginRight: "10px", color: "#A8A8A8", fontSize: "16px" }}
      />{" "}
      {moment(dateTime).format("YYYY.MM.DD")}
    </Box>
  );
};

export default EventStartDate;
